import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

import links from '../links';
import menus from '../menus2';

const Header = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [linkOpen, setLinkOpen] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);

    // Enlaces de Amazon actualizados (en español)
    const amazonLinks = [
        { country: "US", url: "https://www.amazon.com/dp/840976203X?maas=maas_adg_5D3B5D476A41185CD9D0075ED74588D7_afap_abs&ref_=aa_maas&tag=maas", flag: "us.png", currency: "USD" },
        { country: "UK", url: "https://www.amazon.co.uk/dp/840976203X?maas=maas_adg_2380B854318D3EC709F4400CCB2BCD7E_afap_abs&ref_=aa_maas&tag=maas", flag: "gb.png", currency: "GBP" },
        { country: "DE", url: "https://www.amazon.de/dp/840976203X?maas=maas_adg_8A4A1243AF9226603BB25D99FCE73166_afap_abs&ref_=aa_maas&tag=maas", flag: "de.png", currency: "EUR" },
        { country: "FR", url: "https://www.amazon.fr/dp/840976203X?maas=maas_adg_375099402E9609BC757AE5AD99A16277_afap_abs&ref_=aa_maas&tag=maas", flag: "fr.png", currency: "EUR" },
        { country: "ES", url: "https://www.amazon.es/dp/840976203X?maas=maas_adg_6A720AC813E1AD9C76ADB9263BD33E21_afap_abs&ref_=aa_maas&tag=maas", flag: "es.png", currency: "EUR" },
        { country: "IT", url: "https://www.amazon.it/dp/840976203X?maas=maas_adg_B098D7F6010D669676C96BF73637DA59_afap_abs&ref_=aa_maas&tag=maas", flag: "it.png", currency: "EUR" },
        { country: "NL", url: "https://www.amazon.nl/dp/840976203X?maas=maas_adg_3D8D899491E1FFD5D27F4425F387FC92_afap_abs&ref_=aa_maas&tag=maas", flag: "nl.png", currency: "EUR" },
        { country: "PL", url: "https://www.amazon.pl/dp/840976203X", flag: "pl.png", currency: "PLN" },
        { country: "SE", url: "https://www.amazon.se/dp/840976203X", flag: "se.png", currency: "SEK" },
        { country: "JP", url: "https://www.amazon.co.jp/dp/840976203X", flag: "jp.png", currency: "JPY" },
        { country: "CA", url: "https://www.amazon.ca/dp/840976203X?maas=maas_adg_7EC09E874A5E5EECA12B0FB8A943209D_afap_abs&ref_=aa_maas&tag=maas", flag: "ca.png", currency: "CAD" },
        { country: "AU", url: "https://www.amazon.com.au/dp/840976203X", flag: "au.png", currency: "AUD" },
    ];


    // Cierre de dropdown al hacer clic fuera o presionar Escape
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };
        const handleKeyDown = (event) => {
            if (event.key === "Escape") setShowDropdown(false);
        };
        document.addEventListener("click", handleClickOutside);
        document.addEventListener("keydown", handleKeyDown);
        return () => {
            document.removeEventListener("click", handleClickOutside);
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, []);

    // Seguimiento de conversiones y clicks en backend
    const handleAmazonClick = async (link, event) => {
      event?.preventDefault(); // Previene navegación inmediata si es un enlace
    
      // 1️⃣ Registrar click en el backend
      try {
        const backendUrl =
          window.location.hostname === "neuralnetadaptivecontrol.com"
            ? "https://controlbook.onrender.com"
            : "http://localhost:3000";
    
        await fetch(`${backendUrl}/clicks`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            sessionId: "session-" + Math.random().toString(36).substr(2, 9),
            elementId: "amazon-link-cabecera",
            pageUrl: window.location.href,
            elementType: "link",
            userId: "user-react",
            coordinates: event ? { x: event.clientX, y: event.clientY } : null,
            metadata: {
              country: link.country,
              currency: link.currency,
              store: "amazon",
              product: link.product || "neural-networks-book",
            },
          }),
        });
      } catch (err) {
        console.error("Error recording click", err);
      }
    
      // 2️⃣ Google Ads conversion
      if (typeof window.gtag === "function") {
        window.gtag("event", "conversion", {
          send_to: "AW-16832649503/oq0QCPbF0ZYaEJ-yt9o-",
          value: 1.0,
          currency: link.currency,
        });
      }
    
      // 3️⃣ Cerrar dropdown si aplica
      setShowDropdown(false);
    
      // 4️⃣ Abrir enlace de Amazon en nueva pestaña
      window.open(link.url, "_blank");
    };

    return (
        <header className="main-header">
            <div className="site-navigation main_menu" id="mainmenu-area">
                <nav className="navbar navbar-expand-lg">
                    <div className="container">

                        {/* Botón hamburguesa móvil */}
                        <button className="navbar-toggler" type="button" onClick={() => setMenuOpen(!menuOpen)}>
                            <span className="fa fa-bars"></span>
                        </button>

                        {/* Menú principal */}
                        <div className={`navbar-collapse ${menuOpen ? "open" : "close"}`} id="navbarMenu">
                            <ul className="navbar-nav me-auto">
                                <li className="nav-item dropdown">
                                    <Link
                                        to="#"
                                        className="nav-link dropdown-toggle"
                                        id="navbar2"
                                        role="button"
                                        onClick={() => setLinkOpen(!linkOpen)}
                                    >
                                        Home <i className="fa fa-angle-down"></i>
                                    </Link>
                                    <ul className={`dropdown-menu ${linkOpen ? "open" : "close"}`}>
                                        {links.map((data, i) => (
                                            <Link
                                                key={i}
                                                className="dropdown-item"
                                                to={data.tolink}
                                                onClick={() => {
                                                    window.location.href = data.tolink;
                                                }}
                                            >
                                                {data.namelink}
                                            </Link>
                                        ))}
                                    </ul>
                                </li>

                                {menus.map((menu, i) => (
                                    <li className="nav-item" key={i}>
                                        <HashLink
                                            to={menu.tomenu}
                                            className="nav-link js-scroll-trigger"
                                        >
                                            {menu.namemenu}
                                        </HashLink>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Dropdown Amazon */}
                        <div
                            className="header-right-info d-none d-lg-block position-relative"
                            ref={dropdownRef}
                            style={{ position: "relative" }}
                        >
                            <button
                                className="btn btn-dark-bg btn-small dropdown-toggle"
                                type="button"
                                aria-haspopup="true"
                                aria-expanded={showDropdown}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setShowDropdown(!showDropdown);
                                }}
                            >
                                <i className="fa fa-shopping-cart me-2"></i>Get it Now
                            </button>

                            <div
                                className={`dropdown-menu ${showDropdown ? "show" : ""}`}
                                style={{
                                    position: "absolute",
                                    top: "100%",
                                    left: 0,
                                    right: "auto",
                                    marginTop: "5px",
                                    zIndex: 1050,
                                    display: showDropdown ? "block" : "none",
                                    backgroundColor: "#fff",
                                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                                    borderRadius: "0.5rem",
                                    minWidth: "200px",
                                    overflowY: "auto",
                                    maxHeight: "300px",
                                }}
                            >
                                {amazonLinks.map((link) => (
                                    <a
                                        key={link.country}
                                        href={link.url}
                                        className="dropdown-item d-flex align-items-center"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        onClick={() => handleAmazonClick(link)}
                                    >
                                        <img
                                            src={`https://flagcdn.com/w20/${link.flag}`}
                                            alt={link.country}
                                            style={{ width: 20, marginRight: 8 }}
                                        />
                                        <span>Amazon {link.country}</span>
                                    </a>
                                ))}
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </header>
    );
};

export default Header;
